export default ({ logoABT, logoComp }) => [
  {
    title: 'А-БТ', value: logoABT.position, parentName: 'logoABT',
  },
  {
    title: 'Лого </br>компании', value: logoComp.position, parentName: 'logoComp',
  },
];
